import { Component, OnInit } from '@angular/core';
import { LayoutService } from '@d-services';
import { CoreUserService } from '@d-services/core/user.service';
import { FormControl } from '@angular/forms';
import { AppState } from '@d-store/constant';
import { Store, select } from '@ngrx/store';
import {
  getDialogProgramOwnerId,
  updateDialogTenants,
  updateDialogUserLevel,
} from '@d-store/user/user.action';
import { USER_LEVEL } from '@d-constants/user.constant';
import { Router } from '@angular/router';
import { CoreTenantTreeModel } from '@d-models/other/tenant.model';
import { getCurrentUserLevel } from '@d-store/user/user.selector';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  poLogo: string = '';
  constructor(
    public layoutService: LayoutService,
    private coreUserService: CoreUserService,
    private store: Store<AppState>,
    private router: Router,
  ) {}

  tenantOptions: CoreTenantTreeModel[] = [];
  tenant = new FormControl('');

  ngOnInit() {
    if (this.coreUserService.getUserLevel().companyId) {
      this.tenant.setValue(this.coreUserService.getUserLevel().companyId);
    } else if (this.coreUserService.getUserLevel().tenantId) {
      this.tenant.setValue(this.coreUserService.getUserLevel().tenantId);
    }
    this.store.pipe(select(getCurrentUserLevel)).subscribe((val) => {
      if (val.level === USER_LEVEL.PO_LEVEL) this.poLogo = val.logoUrl;
      else this.poLogo = '';
    });
  }

  changeTenant(event: any) {
    if (event.parent) {
      // PO level
      this.store.dispatch(
        getDialogProgramOwnerId({
          name: event.label,
          companyId: event.value,
          tenantId: event.parent.value,
          level: USER_LEVEL.PO_LEVEL,
        }),
      );
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigateByUrl('/home', { state: { level: 2 } });
      });
    } else {
      // Tenant level
      this.store.dispatch(
        updateDialogUserLevel({
          name: event.label,
          companyId: '',
          programOwnerId: '',
          tenantId: event.value,
          level: USER_LEVEL.TENANT_LEVEL,
          logoUrl: '',
        }),
      );
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigateByUrl('/home', { state: { level: 1 } });
      });
    }
  }
}
